import { render, staticRenderFns } from "./WondeImportComponent.vue?vue&type=template&id=783f3f18"
import script from "./WondeImportComponent.vue?vue&type=script&lang=js"
export * from "./WondeImportComponent.vue?vue&type=script&lang=js"
import style0 from "./WondeImportComponent.vue?vue&type=style&index=0&id=783f3f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports